import baseApiMethod from "./baseApiMethod";
import handleApiError, { handleAxiosError } from "./handleApiError";
import baseAxiosMethod from "./baseAxiosMethod";
import Axios, { CancelToken } from "axios";

const adminAPI = {};

const axiosCancelTokens = {};

adminAPI.checkAccessToken = async () => {
  const accessToken = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");
  try {
    const response = await baseAxiosMethod.post(`users/refreshToken`, { accessToken, refreshToken });

    const { accessToken: newAccessToken, refreshToken: newRefreshToken } = response.data.data;

    localStorage.setItem("token", newAccessToken);
    localStorage.setItem("refreshToken", newRefreshToken);

    return response.data.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};

adminAPI.getProcurementCategories = async (key, param) => {
  try {
    const response = await baseAxiosMethod(`procurements/procurementCategories`);
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};

adminAPI.getPermissions = async (key, param) => {
  try {
    const response = await baseAxiosMethod(`roles?Search=${param.Search}`);
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};

adminAPI.getRolesThreshholds = async (key, params) => {
  try {
    const response = await baseAxiosMethod(`roles/thresholds`, { params });
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};
adminAPI.uploadVendor = async ({ payload }) => {
  try {
    const { data } = await baseAxiosMethod.post(`vendors/upload`, payload);
    return data;
  } catch (err) {
    throw new Error(handleAxiosError(err));
  }
};

adminAPI.getRoleThreshold = async (key, { selectedRole, selectedCategory }) => {
  try {
    const response = await baseAxiosMethod(`roles/threshold/${selectedRole}?CategoryId=${selectedCategory}`);
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};

adminAPI.getRoles = async (key, param) => {
  try {
    const response = await baseAxiosMethod(`roles?Search=${param.Search}`);
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};

adminAPI.createPermissionThreshold = async ({ lowerLimitThreshold, upperLimitThreshold, roleId, categoryId }) => {
  try {
    const response = await baseAxiosMethod.post(`roles/threshold/${roleId}`, {
      lowerLimitThreshold,
      upperLimitThreshold,
      procurementCategoryId: categoryId,
    });
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};

adminAPI.updatePermissionThreshold = async ({ lowerLimitThreshold, upperLimitThreshold, roleId }) => {
  try {
    const response = await baseAxiosMethod.put(`roles/threshold/${roleId}`, { lowerLimitThreshold, upperLimitThreshold });
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};

adminAPI.getStaffSummary = (ministryId) => baseApiMethod(null, `staffs/summary?MinistryId=${ministryId}`, "get");

adminAPI.getStaff = async (key, params) => {
  try {
    const response = await baseAxiosMethod("staffs", {
      params,
    });

    const {
      data,
      meta: { pagination },
    } = response.data;

    return { data, pagination };
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.updateStaffStatus = async ({ id, status }) => {
  try {
    const response = await baseAxiosMethod.put(`staffs/${id}`, {
      status,
    });
    return response.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

//Page size zero to make the backend return all ministries
adminAPI.getMinistries = () => baseApiMethod(null, "ministries?pageSize=0", "get");

adminAPI.getMinistriesAxios = async (key, params) => {
  try {
    axiosCancelTokens.getMinistriesAxios && axiosCancelTokens.getMinistriesAxios();

    const response = await baseAxiosMethod("ministries", {
      params,
      cancelToken: new CancelToken(function executor(c) {
        axiosCancelTokens.getMinistriesAxios = c;
      }),
    });

    const {
      data,
      meta: { pagination },
    } = response.data;

    return { data, pagination };
  } catch (e) {
    if (Axios.isCancel(e)) return;
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getPendingStaffInvite = ({ PageNumber = 1, PageSize = 10 }) =>
  baseApiMethod(null, `staffs/pendingInvites?PageNumber=${PageNumber}&PageSize=${PageSize}`, "get");
adminAPI.inviteStaffs = (data) => baseApiMethod({ userInvite: data }, "staffs/invite", "post");
adminAPI.getVendors = async (key, { ...params }) => {
  try {
    axiosCancelTokens.getVendors && axiosCancelTokens.getVendors();

    const response = await baseAxiosMethod(`vendors`, {
      params,
      cancelToken: new CancelToken(function executor(c) {
        axiosCancelTokens.getVendors = c;
      }),
    });

    const {
      data,
      meta: { pagination },
    } = response.data;

    return { data, pagination };
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getPendingVendors = async (key, { SearchBy, Search, ...params }) => {
  try {
    axiosCancelTokens.getPendingVendors && axiosCancelTokens.getPendingVendors();

    params[SearchBy] = Search;
    params.Status = 1;

    const response = await baseAxiosMethod(`vendors`, {
      params,
      cancelToken: new CancelToken(function executor(c) {
        axiosCancelTokens.getPendingVendors = c;
      }),
    });

    const {
      data,
      meta: { pagination },
    } = response.data;

    return { data, pagination };
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};
adminAPI.getVendorsSummary = () => baseApiMethod(null, "vendors/summary", "get");
// adminAPI.updateStaffStatus = (data) => baseApiMethod(data, `staffs/${data.id}`, "put");
adminAPI.resendInvite = (data) => baseApiMethod(data, "staffs/resendInvitation", "post");
adminAPI.revokeInvite = (data) => baseApiMethod(data, "staffs/revokeInvite", "post");

adminAPI.getAllProject = async (key) => {
  try {
    const response = await baseAxiosMethod("projects");
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getVendorProjectSummary = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`projects/summary/vendor/${vendorId}`);
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getContractSummary = async (key, filter) => {
  try {
    const response = await baseAxiosMethod("Summary/contract", { params: filter });
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getAdminOverviewData = async (key) => {
  try {
    const response = await baseAxiosMethod("Summary/staffOverviewSummary");
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getProjects = async (key) => {
  try {
    const response = await baseAxiosMethod("/projects");

    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getVendorProjects = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`projects/${vendorId}/projects`);

    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};
adminAPI.getPaymentHistory = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`payments/users/${vendorId}/history`);

    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getVendorActivities = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`vendors/${vendorId}/Activities`);
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getVendorContractsSummary = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`contracts/summary/vendor/${vendorId}`);
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getVendorBidsSummary = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`bids/summary/${vendorId}/vendor`);
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.getSearchResults = async (key, searchText) => {
  try {
    const response = await baseAxiosMethod(`staffs/search?Search=${searchText}`);
    return response.data;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};
adminAPI.getUploadedDocuments = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`vendors/${vendorId}/documents`);
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};
adminAPI.getDirectorDetails = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`vendors/${vendorId}/directors`);
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};
adminAPI.getVendorsBid = async (_, vendorId) => {
  try {
    const response = await baseAxiosMethod(`bids/vendors/${vendorId}/`);
    return response.data.data;
  } catch (e) {
    throw new Error(handleAxiosError(e));
  }
};

adminAPI.deleteVendor = async (vendorId) => {
  try {
    const response = await baseAxiosMethod.delete(`/generalPlans/${vendorId}/deletevendorprofile`);
    return response.data.data;
  } catch (e) {
    throw handleApiError(e.response?.data, e.response?.statusCode);
  }
};

export default adminAPI;
